module.exports = __webpack_public_path__ + "static/media/house.5f32a7f5.png";